<template>
  <div class="privacy-level-indicator">
      <GlobeIcon v-if="props.value == PrivacyLevel.Everyone"></GlobeIcon>
      <UsersIcon v-else-if="props.value == PrivacyLevel.Groups"></UsersIcon>
      <SmileIcon v-else-if="props.value == PrivacyLevel.Friends"></SmileIcon>
      <LockIcon v-else-if="props.value == PrivacyLevel.Me"></LockIcon>
  </div>
</template>

<style lang="scss" scoped>
.privacy-level-indicator {
  color: #888;
}
</style>

<script setup lang="ts">
import { computed } from 'vue'
import { PrivacyLevel } from '@/gp/GroupAdminModel'
import { GlobeIcon, UsersIcon, SmileIcon, LockIcon } from '@zhuowenli/vue-feather-icons'

const props = defineProps<{
  value: PrivacyLevel
}>()

const displayText = computed(() => props.value)
</script>
